module.exports = __webpack_public_path__ + "static/media/qc.c8d58b87.jpg";